import React from 'react';
import { usePageTitle } from '@utils/hooks/usePageTitle';
import { Switch, Route } from 'react-router-dom';
import { useLearningOutcomeReportsAccess } from '@components/Component/LearningOutcomeReports/IsLearningOutcomeReportsFlagEnabled';
import ShowIf from '@components/Atoms/ShowIf';
import { useIsDistrictAdmin, useIsStudent, useHasRole } from '@reducers/user/hooks';
import Typography from '@components/Atoms/Typography';
import LeftSideBarAdmin from '../../containers/LeftSideBar/LeftSideBarAdmin';
import MainContent from '../../containers/MainContent';
import AdminReports from '../../containers/AdminReports/AdminReports';
import ReportGeneratorRouter from '../ReportGenerator/ReportGeneratorRouter';
import Skeleton from '../Atoms/Skeleton/Skeleton';
import { useAvailableReportsQuery, useReportsFeatureAccessQuery } from '../ReportGenerator/ReportQueries';
import { AdminDistrictReportsWrapper } from './DistrictReports';
import PMOutcomesPage from './PMOutcomes';
import { AccountabilityPage } from './Accountability';

const Admin = () => {
  usePageTitle('Admin Reports');
  const hasRole = useHasRole();
  const isStudent = useIsStudent();
  const { isLoading, data: availableReportsData } = useAvailableReportsQuery();
  const isDistrictAdmin = useIsDistrictAdmin();
  const isLearningOutcomeReportsEnabled = useLearningOutcomeReportsAccess({
    suspense: true,
  });
  const isPMReportsEnabled = useReportsFeatureAccessQuery('pm_reports');
  const isAccountabilityEnabled = useReportsFeatureAccessQuery('accountability_reports');
  const isStudentSkillLevelReportEnabled = useReportsFeatureAccessQuery('student_skill_level_report');

  if (isLoading) {
    return (
      <>
        <LeftSideBarAdmin />
        <MainContent>
          <Skeleton style={{ margin: '5rem' }} variant="rectangular" width="80%" height={800} />
        </MainContent>
      </>
    );
  }

  const dataDashboardAvailable = availableReportsData?.data_dashboard_available || false;

  return (
    <>
      <LeftSideBarAdmin />
      <MainContent>
        <ShowIf If={hasRole}>
          <Switch>
            <Route path="/admin/reports/generator/">
              <ShowIf If={!isStudent || isStudentSkillLevelReportEnabled}>
                <ReportGeneratorRouter availableReportsData={availableReportsData} />
              </ShowIf>
            </Route>
            <Route exact path="/admin/reports/pm-outcomes">
              <ShowIf If={!isStudent && isPMReportsEnabled}>
                <PMOutcomesPage />
              </ShowIf>
            </Route>
            <Route exact path="/admin/reports/accountability">
              <ShowIf If={!isStudent && isAccountabilityEnabled}>
                <AccountabilityPage />
              </ShowIf>
            </Route>
            <Route exact path="/admin/reports/learning-outcomes">
              <ShowIf If={!isStudent && isDistrictAdmin && isLearningOutcomeReportsEnabled}>
                <AdminDistrictReportsWrapper />
              </ShowIf>
            </Route>
            <Route exact path="/admin/reports/data-dashboard">
              <ShowIf If={!isStudent && dataDashboardAvailable}>
                <AdminReports />
              </ShowIf>
            </Route>
            <Route>
              <Typography variant="h1" align="center" style={{ marginTop: '5rem', fontSize: '3rem' }}>
                Select a report to view from the left sidebar
              </Typography>
            </Route>
          </Switch>
        </ShowIf>
      </MainContent>
    </>
  );
};

export default Admin;
